require('../../modules/es6.object.assign');
module.exports = require('../../modules/_core').Object.assign;



//////////////////
// WEBPACK FOOTER
// ./~/async-validator/~/core-js/library/fn/object/assign.js
// module id = 182
// module chunks = 1